import React, { useEffect, useRef } from 'react';
import { getWsUrl } from 'helpers/ws-requests/ws';
import { apiWsPaths } from 'config';
import RFB from '@novnc/novnc/lib/rfb';

const Playground = ({ vmId }) => {
  const vncRef = useRef(null);
  const rfbRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (rfbRef.current) {
        rfbRef.current.scaleViewport = true;
        rfbRef.current.resizeSession = true;
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Local → Cloud Desktop: push local clipboard to Cloud Desktop when window regains focus
  useEffect(() => {
    const syncClipboardToVm = async () => {
      try {
        if (rfbRef.current && navigator.clipboard) {
          const text = await navigator.clipboard.readText();
          if (text) {
            rfbRef.current.clipboardPasteFrom(text);
          }
        }
      } catch {
        // Clipboard read permission not granted
      }
    };

    window.addEventListener('focus', syncClipboardToVm);
    return () => window.removeEventListener('focus', syncClipboardToVm);
  }, []);

  useEffect(() => {
    let ws = null;

    const initVNC = () => {
      if (vncRef.current && !rfbRef.current) {
        ws = new WebSocket(getWsUrl(apiWsPaths.appVms.vms.screen(vmId)));

        const rfb = new RFB(vncRef.current, ws, {
          shared: true,
          resizeSession: true,
          scaleViewport: true,
          clipViewport: true
        });

        rfb.addEventListener('connect', () => {
          rfb.scaleViewport = true;
          rfb.resizeSession = true;
        });

        // Cloud Desktop → Local: update local clipboard when Cloud Desktop clipboard changes
        rfb.addEventListener('clipboard', e => {
          if (navigator.clipboard && e.detail.text) {
            navigator.clipboard.writeText(e.detail.text).catch(() => {});
          }
        });

        rfb.addEventListener('disconnect', e => {
          rfbRef.current = null;
          if (!e.detail.clean) {
            setTimeout(initVNC, 5000);
          }
        });

        rfbRef.current = rfb;
      }
    };

    initVNC();

    return () => {
      if (rfbRef.current) {
        rfbRef.current.disconnect();
        rfbRef.current = null;
        if (ws) {
          ws.close();
        }
      }
    };
  }, []);

  return (
    <div
      ref={vncRef}
      style={{
        width: '100%',
        height: '100%'
      }}
    />
  );
};

export default Playground;
